import { DataTypeEnum } from "../../common/enums/DataTypeEnum";
import { DateRangeType } from "../../common/enums/DRCXEnums";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { RecipientSubTypeEnum } from "../../common/enums/RecipientSubTypeEnum";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { SetpointScheduleUnitEnum } from "../../common/enums/SetpointScheduleUnitEnum";
import { SetPointTypeEnum } from "../../common/enums/SetpointTypeEnum";
import { SetPointVarianceTimeframeEnum } from "../../common/enums/SetpointVarianceTimeframeEnum";
import { SetPointVarianceTypeEnum } from "../../common/enums/SetpointVarianceTypeEnum";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";

export interface IEditDTO {

    organizationID: number;

    setPointID: number;                                             // SetPointID
    setPointName: string;                                           // SetPointName

    setPointType: SetPointPrecedenceTypeEnum;///

    isDiscrete: boolean;                                            // sp_Discrete => True = Field Alarm, False = Database Alarm
    comparisonType: SetPointTypeEnum;                               // sp_spt_id

    operator: string;                                               // SetPointOperator
    value: number;                                                  // SetPointValue
    unitOfMeasureID: number;                                        // sp_uom_id

    varianceType: SetPointVarianceTypeEnum;                   // sp_variance_type_id
    varianceWindow: number;                                         // sp_variance_window
    varianceTimeframeType: SetPointVarianceTimeframeEnum;     // sp_variance_timeframe_dtt_id

    emailAlarmMessageSubject: string;                               // sp_event_subject
    emailAlarmMessageBody: string;                                  // SetPointEventMessage
    voiceAlarmMessageBody: string;                                  // SetPointVoiceEventMessage

    emailClearMessageSubject: string;                               // sp_clear_subject
    emailClearMessageBody: string;                                  // SetPointClearMessage
    voiceClearMessageBody: string;                                  // SetPointVoiceClearMessage


    sampleEmailAlarmMessageSubject?: string;
    sampleEmailAlarmMessageBody?: string;
    sampleVoiceAlarmMessageBody?: string;
    
    sampleEmailClearMessageSubject?: string;
    sampleEmailClearMessageBody?: string;
    sampleVoiceClearMessageBody?: string;




    alarmColor: string;                                             // SetPointAlarmColor
    acknowledgeColor: string;                                       // SetPointAckColor

    notifyOnAlarm: boolean;                                         // SetPointEventNotify
    notifyOnNormal: boolean;                                        // SetPointClearNotify

    suppressAlarmAlarm: boolean;                                    // SetPointSuppressAlarmAlarm
    suppressNormalNormal: boolean;                                  // SetPointSuppressNormalNormal

    // DO WE NEED THESE ON THE CLIENT?
    // They don't seem to be bound to the UI or be needed for validation on the client
    //createdTimestamp: Date;                                // sp_created_timestamp;
    //createdTimestampDto: Date;                             // sp_created_timestamp_dto;
    //eventType: SetPointEventTypeEnum;                         // SetPointEventTypeID
    //independent?: boolean;                                          // SetPointIndependent
    //isDisabled: boolean;                                            // SetPointDisabled
    //messageComplete: boolean;                                       // sp_message_complete
    //precedence: number;                                             // SetPointPrecedence; 0 for Field Alarms (e.g. isDiscrete === true)
    //suppressAlarmAlarm?: boolean;                                   // SetPointSuppressAlarmAlarm
    //suppressNormalNormal?: boolean;                                 // SetPointSuppressNormalNormal
    //thresholdType: SetPointThresholdTypeEnum;                 // SetPointThresholdTypeID

    alarmSchemeID?: number;

    alarmSchemes: IReferenceAlarmSchemeDTO[];
    
    notificationLists: Array<IEditNotificationListDTO>;

    originalNotificationLists?: IEditNotificationListDTO[];

    recipients: Array<IEditRecipientDTO>;

    tags: Array<IEditTagDTO>;

    hasEvaluationPropertyChanges: boolean;

    tagLevelEdit: boolean;
    tagID?: number;

    textValue: string;
    dataType: DataTypeEnum;
    customMessaging: boolean;

    unitClassification?: number;

    timespanType: DateRangeType;                                // sp_time_comparison_timespan_dtt_id

}

export interface IEditNotificationListDTO {
    organizationID: number;
    notificationListID: number;
}

export interface IEditRecipientDTO {
    organizationID: number;
    userID: number;
    recipientID: number;
    disabled?: boolean;


    selected?: boolean; 
}

export interface IEditTagDTO {
    // Device Fields
    tagObjectID: number;
    tagObjectName: string;
    tagObjectTypeID: number;
    // Tag Fields
    tagID: number;
    tagName: string;
    tatID: number;
    tagHidden: boolean;
    tagDisabled: boolean;
    //tagUnitName: string;
    //currentValueText: string;
    //currentValueTimestamp?: Date;

    // TagSetPointBridge Fields
    //inAlarm: boolean;
    //isAcknowledged: boolean;
    //isDisabled: boolean;
    notifyOnAlarm: boolean;
    notifyOnNormal: boolean;
    //lastAlarmValue?: number;
    //alarmEndReason?: AlarmNotificationEndingReasonEnum;
    //acknowledgeByName: string;
    //acknowledgeTimestamp?: Date;
    //acknowledgeExplanation: string;
    //acknowledgeSource: string;
    tagUnitOfMeasureID: number;
    tagUomIsIncompatible: boolean;

    selected?: boolean; //@@foo
}

export interface IEditTagSearchCriteriaDTO {
    tagObjectName?: string;
    startGroupID: number;
    deviceTypeID?: number;
    isDiscrete: boolean;
    tagAssociationTypeIDs: Array<number>;
    unitOfMeasureID?: number;
    tagObjectTypeID?: number;
    dataTypeID?: number;
}

export interface IEditTagSearchResultDeviceDTO {
    id: number;
    name: string;
    objectTypeID: number;
    tags: Array<IEditTagSearchResultTagDTO>;
    expanded?: boolean;
    allowSelection?: boolean;
    selectedTagsCount?: number;    
}

export interface IEditTagSearchResultTagDTO {
    id: number;
    name: string;

    selected?: boolean;
}


// Reference Data DTOs
export interface IReferenceDTO {
    alarmSchedules: Array<IReferenceAlarmScheduleDTO>;
    alarmSchemes: Array<IReferenceAlarmSchemeDTO>;
    deviceTypes: Array<IReferenceDeviceTypeDTO>;
    messages: Array<IReferenceMessageDTO>;
    notificationLists: Array<IReferenceNotificationListDTO>;
    organizations: Array<IReferenceOrganizationDTO>;
    recipients: Array<IReferenceRecipientDTO>;
    tagAssociationTypes: Array<IReferenceTagAssociationTypeDTO>;
    unitClassifications: Array<IReferenceUnitClassificationDTO>;
    unitsOfMeasure: Array<IReferenceUnitOfMeasureDTO>;
    users: Array<IReferenceUserDTO>;
}

export interface IReferenceAlarmScheduleDTO {
    id: number;
    name: string;
    notificationLists: IReferenceNotificationListDTO[]; 
}

export interface IReferenceAlarmSchemeDTO {
    id: number,
    name: string,
    tiers: Array<IReferenceAlarmSchemeTierDTO>;


    selected?: boolean
}

export interface IReferenceAlarmSchemeTierDTO {
    id: number;
    name: string;
    description: string;
    notifications: Array<IReferenceAlarmSchemeTierNotificationDTO>;
    schedules: IReferenceAlarmScheduleDTO[];

}

export interface IReferenceAlarmSchemeTierNotificationDTO {
    scheduleID: number;
    notificationListID: number;

    notificationListName?: string;
    organizationID?: number;
}

export interface IReferenceDeviceTypeDTO {
    id: number;
    name: string;
}

export interface IReferenceMessageDTO {
    id: number,
    friendlyName: string;
    template: string;
    isAnalogDefault: boolean;
    isDiscreteDefault: boolean;
    sampleText: string;
    isBody: boolean;
    isSubject: boolean;
    isAlarmOnly: boolean;
    isClearOnly: boolean;
    isVarianceDefault: boolean;
    objectType: eLynxObjectTypeEnum;
    dataType: DataTypeEnum;
    isTimeComparisonDefault: boolean;
}

export interface IReferenceNotificationListDTO {
    id: number;
    name: string;
    organizationID: number;

    selected?: boolean;
}

export interface IReferenceOrganizationDTO {
    id: number;
    name: string;
}

export interface IReferenceRecipientDTO {
    id: number;
    to: string;
    type: RecipientTypeEnum;
    subType?: RecipientSubTypeEnum;
    organizationID: number;
    userID: number;
    disabled?: boolean;
}

export interface IReferenceTagAssociationTypeDTO {
    id: number;
    name: string;
    dataType: DataTypeEnum;
}

export interface IReferenceUnitClassificationDTO {
    id: number;
    name: string;
}

export interface IReferenceUnitOfMeasureDTO {
    unitClassificationID: number;
    id: number;
    name: string;
}

export interface IReferenceUserDTO {
    id: number;
    name: string;
    isDisabled: boolean;
}


// Summary Format DTOs
export interface ISummaryDTO {
    page: number;
    pageSize: number;
    totalPages: number;
    totalSetPoints: number;
    setPoints: Array<ISummarySetPointDTO>;
    hasObjects: boolean;
}

export interface ISummaryObjectSetPointsDTO {
    setPointObject: IeLynxObject;
    setPoints: Array<ISummarySetPointDTO>;
}

export interface ISummaryGroupedObjectsDTO {
    page: number;
    pageSize: number;
    totalPages: number;
    totalObjects: number;
    objectSetPoints: Array<ISummaryObjectSetPointsDTO>;
}

export interface ISummaryObjectsDTO {
    page: number;
    pageSize: number;
    totalPages: number;
    totalObjects: number;
    objects: Array<IeLynxObject>;
}

export interface ISummarySearchDTO {
    organizationID?: number;
    databaseAlarms?: boolean;
    fieldAlarms?: boolean;
    enabledSetPoints?: boolean;
    disabledSetPoints?: boolean;
    setPointName?: string;
    tagObjectName?: string;
    tagAssociationTypeIDs?: Array<number>;
    tagObjectTypeID?: number;
}

export interface ISummarySetPointDTO {
    id: number;
    name: string;
    description: string;
    type: SetPointTypeEnum;
    isDisabled: boolean;
    isDiscrete: boolean;
    acknowledgeColor: string;
    alarmColor: string;
    linkedTagCount: number;
    hasTagsInAlarm: boolean;
    usage: Array<ISummaryUsageDTO>;

    selected?: boolean;
}

export interface ISummaryUsageDTO {
    setPointID: number;
    tagObjectID: number;
    tagObjectName: string;
    tagObjectTypeID: number;
    tagID: number;
    tagName: string;
    inAlarm: boolean;
    isAcknowledged: boolean;
    isDisabled: boolean;
    valueText: string;
    valueDate: Date;
    displayTimeframe?: TimeframeTypeEnum;
    disabledUntil: string;
    tagHidden: boolean;
    tagDisabled: boolean;
    totalTagCount: number;
    tagUomIsIncompatible: boolean;

    //acknowledgedBy: string;
    //acknowledgeDateTime?: Date;
    //notificationEndingReason?: AlarmNotificationEndingReasonEnum;
    notifyOnAlarm: boolean;
    notifyOnNormal: boolean;
    //disableAcknowledge: boolean;
    //value: number;
    //valueUnit: string;
}


// Disabled Schedule DTO
export interface IDisabledScheduleDTO {
    tagID: number;
    setPointID: number;
    duration: number;
    durationUnit: SetpointScheduleUnitEnum;
    beginsOn: Date;
    endsOn: Date;
    timezone: string;
    olsonTimezone: string;
    defaultDuration: boolean;
}


export enum SetPointPrecedenceTypeEnum {
    Database = 0,
    Field = 1

}

export type AvailableSetpointModel = {
    id: number;
    name: string;
    description: string;
}

const defaultEditSetpoint: IEditDTO = {
    organizationID: 0,

    setPointID: 0,
    setPointName: '',
    setPointType: SetPointPrecedenceTypeEnum.Database, //@@setPointType
    isDiscrete: false,
    comparisonType: SetPointTypeEnum.ValueComparison,
    operator: '<',
    value: 0,
    unitOfMeasureID: 0,
    varianceType: SetPointVarianceTypeEnum.Either,
    varianceWindow: 10,
    varianceTimeframeType: SetPointVarianceTimeframeEnum.Days,
    
    timespanType: DateRangeType.Minute,

    emailAlarmMessageSubject: '',
    emailAlarmMessageBody: '',

    voiceAlarmMessageBody: '',

    emailClearMessageSubject: '',
    emailClearMessageBody: '',

    voiceClearMessageBody: '',

    alarmColor: 'Red',
    acknowledgeColor: 'Green',

    notifyOnAlarm: true,
    notifyOnNormal: true,

    suppressAlarmAlarm: true,
    suppressNormalNormal: true,


    alarmSchemeID: 0,

    alarmSchemes: [],
    notificationLists: [],
    originalNotificationLists: [],

    recipients: [],

    tags: [],

    hasEvaluationPropertyChanges: false,

    tagLevelEdit: false,
    //tagID?: number;

    textValue: '',
    dataType: DataTypeEnum.Double,
    customMessaging: false,


    unitClassification: -1,
 };

export {defaultEditSetpoint}

